import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import CellarLocation from 'components/CellarLocation'

class CellarLocations extends React.Component {
  render() {
    const { cellarId, locations, eventsCurrentLanguage } = this.props

    const cellarLocations = []
    for (const locationId of Object.keys(locations)) {
      const location = locations[locationId][eventsCurrentLanguage]
      if (location && location.cellar === cellarId) {
        cellarLocations.push(location)
      }
    }

    const locationItems = cellarLocations.map(location => {
      return (
        <CellarLocation key={location._id} location={location} />
      )
    })

    return (
      <div className="locations">
        <div className="wrap">
          <h2 className="locations__title">
            <FormattedMessage id="app.cellar.locations.title" />
          </h2>
          { locationItems }
        </div>
      </div>
    )
  }
}

CellarLocations.propTypes = {
  cellarId: PropTypes.string.isRequired,
  locations: PropTypes.object.isRequired,
  eventsCurrentLanguage: PropTypes.string.isRequired,
}

export default CellarLocations
